import React, { useState, useEffect, useRef, Fragment } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Dialog,
    Grid,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    TableFooter,
    IconButton,
    TablePagination,
    Divider,
    TextField,
    FormControl,
} from "@material-ui/core";
import { connect } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { DownloadOutlined, EyeOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import HttpService from "../../services/httpService";
import { CSVLink } from "react-csv";
import PropTypes from "prop-types";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import LastPageIcon from "@material-ui/icons/LastPage";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { fontWeight, palette } from "@mui/system";
import { commaSeparateAmount } from "../../components/commaSeparate";
import { paymentMode } from "../../utils";
import { Link } from "react-router-dom";
import CashFreeExcelFilePreview from "../../assets/img/org/Cash_Free_Excel_File_Preveiw.png"
import CardPineLabExcelFilePreview from "../../assets/img/org/Card_Pine_Lab_Excel_File_Preveiw.png"

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 850,
    },
    textField: {
        width: 100,
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        width: "auto",
        // maxWidth: 400,
    },
    clickableTableCell: {
		cursor: "pointer",
		textDecoration: "underline",
		color: "#1C375D",
	},
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
          backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
      },
    searchButton: {
        backgroundColor: '#FDB913 !important',  // Bright Yellow for emphasis
        color: '#1C375D !important',            // Dark Blue text for contrast
        '&:hover': {
          backgroundColor: '#E6A411 !importan', // Darker yellow on hover
        },
      },
      uploadButton: {
        backgroundColor: '#1C375D',   // Dark Blue
        color: '#FFFFFF',  
        margin:"3px",           // White text
        '&:hover': {
          backgroundColor: '#2A4B6C', // Lighter Dark Blue on hover
        },
      },
}));

const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: "#FFF2EB",
        fontWeight: "500",
        // border: '1px solid black'
    },
    body: {
        fontSize: 14,
        // border: '1px solid red'
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === "rtl" ? (
                    <LastPageIcon />
                ) : (
                    <FirstPageIcon />
                )}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                ) : (
                    <KeyboardArrowLeft />
                )}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                ) : (
                    <KeyboardArrowRight />
                )}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === "rtl" ? (
                    <FirstPageIcon />
                ) : (
                    <LastPageIcon />
                )}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const ApprovedPaymentReceivedAnalysis = (props) => {
    const classes = useStyles();
    const [approvedPaymentData, setApprovedPaymentData] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [paymentFileUploadType, setPaymentFileUploadType] = useState("");
    const [uploadedFilePath, setUploadedFilePath] = useState("");
    const [showExcelFileFormat, setShowExcelFileFormat] = useState(false);
    const paymentFilesType = [paymentMode.cashFree, paymentMode.cardPineLabsErp];
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [detailDataArray, setDetailDataArray] = useState([]);
    const [title, setTitle] = useState("");
    const [csvDataForDetailedTrx, setCsvDataForDetailedTrx] = useState([]);
    const csvButtonRefForDetailedTrx = useRef(null);

    // Headers to for csv
    const headers = [
        { key: "date", label: "Date" },
        { key: "upi", label: "UPI (Automatic)" },
        { key: "cashfree", label: "Cash Free (Automatic)" },
        {
            key: "bankTransferVirtual",
            label: "Bank Transfer Virtual Payment (Automatic)",
        },
        { key: "cardPineLabs", label: "Card - Pine Labs (Automatic)" },
        { key: "totalAutomatic", label: "Total (Automatic)" },
        { key: "cheque", label: "Cheque (Manual)" },
        {
            key: "cardPineLabsNotErp",
            label: "Card - Pine Labs (not via ERP) (Manual)",
        },
        {
            key: "bankTransferNonVirtual",
            label: "Bank Transfers - Non Virtual Account (Manual)",
        },
        { key: "cash", label: "Cash (Manual)" },
        { key: "others", label: "Others (Manual)" },
        { key: "totalManual", label: "Total (Manual)" },
        { key: "grandTotal", label: "Grand Total" },
    ];

    // Headers to for csv for detailed trx
    const headersForDetailedTrx = [
        { key: "slNo", label: "Sl No." },
        { key: "uniqueLeadNumber", label: "Unique Lead Number" },
        { key: "lead_no", label: "Lead No." },
        { key: "customerName", label: "Customer Name" },
        { key: "paymentMode", label: "Payment Mode" },
        { key: "trxId", label: "Trx Id" },
        { key: "amountReceived", label: "Amount Received" },
        { key: "bankCharges", label: "Bank Charges" },
        { key: "gstAmount", label: "GST" },
        { key: "netAmountReceived", label: "Net Amount Received" },
        { key: "bankReceiptDate", label: "Bank Receipt Date" },
        { key: "status", label: "Status" },
        { key: "departmentName", label: "Department Name" },
    ];

    // Function to fetch approved payments data
    const fetchApprovedPaymentsHandler = async (startDate, endDate) => {
        props.setLoading(true);
        try {
            let payload = { startDate, endDate, page, rowsPerPage };
            const response = await HttpService.fetchApprovedPaymentsData(
                payload
            );
            setApprovedPaymentData(response.data);
            // console.log("Response -> ", response.data);
        } catch (error) {
            console.error("Error -> ", error);
        }
        props.setLoading(false);
    };

    // filter function for date range
    const fetchApprovedPaymentsOnSelectedDate = () => {
        fetchApprovedPaymentsHandler(startDate, endDate);
    };

    // function to clear date filter
    const clearFilterDate = (e) => {
        setStartDate("");
        setEndDate("");
        fetchApprovedPaymentsHandler("", "");
    };

    // function to download data in csv
    const csvDownloadHandler = async () => {
        props.setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < approvedPaymentData.length; i++) {
                let el = approvedPaymentData[i];
                let obj = {
                    date: el?.date,
                    upi: el?.Automatic?.UPI?.total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                        currency: "INR",
                    }),
                    cashfree: el?.Automatic?.Cash_Free?.total?.toLocaleString(
                        "en-IN",
                        { maximumFractionDigits: 2, currency: "INR" }
                    ),
                    bankTransferVirtual:
                        el?.Automatic?.Bank_Transfer_Virtual_Payment?.total?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 2, currency: "INR" }
                        ),
                    cardPineLabs:
                        el?.Automatic?.Card_Pine_Labs?.total?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 2, currency: "INR" }
                        ),
                    totalAutomatic:
                        el?.Automatic?.grandTotal?.total?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 2, currency: "INR" }
                        ),
                    cheque: el?.Manual?.Cheque?.total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                        currency: "INR",
                    }),
                    cardPineLabsNotErp:
                        el?.Manual?.Card_Pine_Labs?.total?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 2, currency: "INR" }
                        ),
                    bankTransferNonVirtual:
                        el?.Manual?.Bank_Transfer_Non_Virtual_Payment?.total?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 2, currency: "INR" }
                        ),
                    cash: el?.Manual?.Cash?.total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                        currency: "INR",
                    }),
                    others: el?.Manual?.Others?.total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                        currency: "INR",
                    }),
                    totalManual: el?.Manual?.grandTotal?.total?.toLocaleString(
                        "en-IN",
                        { maximumFractionDigits: 2, currency: "INR" }
                    ),
                    grandTotal: el?.grandTotal?.total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                        currency: "INR",
                    }),
                };
                csvArray.push(obj);
                /*
                obj = {
                    date: "",
                    upi: "",
                    cashfree: "",
                    bankTransferVirtual: "",
                    cardPineLabs: "",
                    totalAutomatic: "",
                    cheque: "",
                    cardPineLabsNotErp: "",
                    bankTransferNonVirtual: "",
                    cash: "",
                    others: "",
                    totalManual: "",
                    grandTotal: "",
                };
                csvArray.push(obj);
                */
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.error("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    // A helper function for csv download
    const downloadExcel = () => {
        props.setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        props.setLoading(false);
    };

    // Function to download data in csv for detailed trx
    const csvDownloadHandlerForDetailedTrx = async () => {
        props.setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < detailDataArray.length; i++) {
                let el = detailDataArray[i];
                let obj = {
                    slNo: i+1,
                    uniqueLeadNumber: el?.leadId?.uniqueLeadNumber,
                    lead_no: el?.leadId?.lead_no,
                    customerName: el?.leadId?.customerId?.name || "N/A",
                    paymentMode: el?.selectedPaymentMode,
                    trxId: el?.trxId,
                    amountReceived: el?.Amount_Received || 0,
                    bankCharges: el?.bankCharges || 0,
                    gstAmount: el?.gstAmount || 0,
                    netAmountReceived: (el?.Amount_Received - el?.bankCharges - el?.gstAmount) || 0,
                    bankReceiptDate: el?.formattedDate,
                    status: el?.Status,
                    departmentName: el?.departmentId?.name || "N/A",
                };
                csvArray.push(obj);
            }
            setCsvDataForDetailedTrx(csvArray);
            downloadExcelForDetailedTrx();
        } catch (error) {
            console.error("Error -> ", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    // A helper function for csv download for detailed trx
    const downloadExcelForDetailedTrx = () => {
        props.setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRefForDetailedTrx.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        props.setLoading(false);
    };

    // Function to handle the change in page
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // Function to handle change in rows per page
    const handleChangeRowsPerPage = (event) => {
        if (event.target.value === "All") {
            setRowsPerPage(parseInt(totalPages, 10));
        } else {
            setRowsPerPage(parseInt(event.target.value, 10));
        }
        setPage(0);
    };

    // Function to handle change in file upload type
    const handleSelect = async (event, value) => {
        try {
            if (value) {
                setPaymentFileUploadType(value);
                setUploadedFilePath("");
            } 
        } catch (error) {
            console.error(error)
            props.setSnackInfo('Couldn\'t fetch the data', 'error')
        }
    }

    // Function to handle File Upload
    const handleUploadFile = async(event)=>{
        props.setLoading(true)
        try{
            if(paymentFileUploadType === ""){
                props.setLoading(false);
                return props.setSnackInfo("Please Select Payment File Type", "error");
            }
            const fd = new FormData();
            fd.append('file', event.target.files[0]);
            const res = await HttpService.uploadFile(fd);
            /**
             * ! Should upload this path somewhere in db and 
             * ! read this file and check whether this is a file for cash free
             */
            setUploadedFilePath(res.data);
            fd.append('paymentFileUploadType', paymentFileUploadType);
            fd.append('fileLocation', res.data);

            let payload = {fileLocation: res.data, paymentFileUploadType, fd};
            let response;
            if(res.data){
                response = await HttpService.addReceiptDateByReference(fd);
            }
            props.setSnackInfo(response?.data?.message ?? "Data Updated", response?.data?.type ?? "success");
            if(response.data.uploadedCPLabFileReportLink){
                window.open(response.data.uploadedCPLabFileReportLink);
            }
        }
        catch(err){
            console.error(err);
            props.setSnackInfo(err.response.data.message ?? "Something went wrong","error");
        }
        props.setLoading(false);
        event.target.value = null;
    }

    // Function to handle bank report file Upload
    const handleUploadBankReportFile = async (event) => {
		props.setLoading(true);
		try {
			const fd = new FormData();
			fd.append("file", event.target.files[0]);
			const res = await HttpService.uploadFile(fd);
			fd.append("bankFormatReportFile", "bankFormatReportFile");
			fd.append("fileLocation", res.data);

			let payload = { fileLocation: res.data, fd };
			let response;
			if (res.data) {
				response = await HttpService.addBankReceiptDateByAppCode(fd);
			}
			props.setSnackInfo(
				response?.data?.message ?? "Data Updated",
				response?.data?.type ?? "success"
			);
			if (response.data.uploadedBankReportFileLink) {
				window.open(response.data.uploadedBankReportFileLink);
			}
		} catch (err) {
			console.error(err);
			props.setSnackInfo(
				err.response.data.message ?? "Something went wrong",
				"error"
			);
		}
		props.setLoading(false);
		event.target.value = null;
	};

    // Function to show Detailed Trx
	const showDetailedModalHandler = (data, text) => {
		try {
            if(data.length === 0){
                return props.setSnackInfo("No transactions available.", "warning");
            }
			setShowDetailedModal(true);
			setTitle(text);
			setDetailDataArray(data);
		} catch (error) {
			console.error("Error -> ", error);
		}
	};

    useEffect(() => {
        fetchApprovedPaymentsHandler("", "");
    }, []);

    return (
        <div>
            <div
                style={{
                    marginBottom: 20,
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Paper className={classes.paper}>
                    <center>
                        <h2>Approved Payment Receipts</h2>
                    </center>
                </Paper>
            </div>

            {/* Date Filter component */}
            <Paper style={{ padding: 10, marginBottom: 10 }}>
                <Grid
                    container
                    style={{ display: "flex", alignItems: "center" }}
                >
                    <Grid item md={3} xs={12}>
                        <TextField
                            id="date"
                            name="startDate"
                            label="From Received Date"
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            fullWidth
                            // className={classes.textField}
                        />
                    </Grid>
                    <Grid item md={1} xs={12}></Grid>
                    <Grid item md={3} xs={12}>
                        <TextField
                            id="date"
                            name="endDate"
                            label="To Received Date"
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                max: moment().format("YYYY-MM-DD"),
                                onKeyDown: (e) => e.preventDefault(),
                            }}
                            fullWidth
                            // className={classes.textField}
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <Button
                            variant="contained"
                            // disabled={!startDate || !endDate}
                            onClick={fetchApprovedPaymentsOnSelectedDate}
                            style={{ marginLeft: 10 }}
                            className={classes.submitButton}
                        >
                            Submit
                        </Button>
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={clearFilterDate}
                        >
                            Clear Filter
                        </Button>
                    </Grid>

                    {/* Download CSV Button */}
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <CSVLink
                            headers={headers}
                            filename={
                                "Approved Payment Received Analysis " +
                                new Date()
                                    .toLocaleDateString()
                                    .replaceAll("/", "_") +
                                ".csv"
                            }
                            data={csvData}
                            ref={csvButtonRef}
                        />
                        <Button
                            onClick={csvDownloadHandler}
                            style={{ margin: 10, backgroundColor: "#355025",color:"#FFF2EB" }}
                            variant="contained"
                        >
                            Download CSV
                        </Button>
                    </div>

                    {/* Drowp Down to upload the file */}
                    <div style={{ display: "flex", alignItems: "center", margin: 10 }}>
                        <Autocomplete
                            value={paymentFileUploadType}
                            onChange={handleSelect}
                            id="payment-file-dropdown"
                            options={paymentFilesType}
                            getOptionLabel={(option) => option}
                            style={{ width: 250 }}
                            renderInput={(params) => <TextField {...params} label="Select Payment File Type" fullWidth variant="outlined" />}
                        />
                        <Fragment>
                            <TextField
                                accept="*"
                                id="payment-file"
                                type="file"
                                onChange={handleUploadFile}
                                style={{ display: 'none' }}
                            />
                            <label htmlFor={`payment-file`}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                    className={classes.uploadButton}
                                >
                                    Upload File
                                </Button>
                                {/* {isFileUploaded && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />} */}
                            </label>
                        </Fragment>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.uploadButton}
                            component="span"
                            onClick={() => setShowExcelFileFormat(true)}
                        >
                            Preview File Format
                        </Button>
                        {/* Bank Report File Upload */}
                        <Fragment>
                            <TextField
                                accept="*"
                                id="bank-report-file"
                                type="file"
                                onChange={handleUploadBankReportFile}
                                style={{ display: 'none' }}
                            />
                            <label htmlFor={`bank-report-file`}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.uploadButton}
                                    component="span"
                                >
                                    Upload Bank Report File
                                </Button>
                            </label>
                        </Fragment>
                    </div>
                </Grid>
            </Paper>

            {/* Data Mapping of Approved Payment Received */}
            <TableContainer component={Paper}>
                <Table
                    className={classes.table}
                    size="small"
                    aria-label="customized table"
                    stickyHeader
                >
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell rowSpan={2}>Sl No</StyledTableCell>
                            <StyledTableCell rowSpan={2}>Date</StyledTableCell>
                            <StyledTableCell colSpan={5} align="center">
                                Payment Mode Automatic
                            </StyledTableCell>
                            {/*
                            <StyledTableCell rowSpan={2}>
                                Total (Automatic)
                            </StyledTableCell>
                            */}
                            <StyledTableCell colSpan={6} align="center">
                                Payment Mode Manual
                            </StyledTableCell>
                            {/*
                            <StyledTableCell rowSpan={2}>
                                Total (Manual)
                            </StyledTableCell>
                            */}
                            <StyledTableCell rowSpan={2}>
                                Grand Total
                            </StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>UPI</StyledTableCell>
                            <StyledTableCell>Cash free</StyledTableCell>
                            <StyledTableCell>
                                Bank Transfer Virtual Payment
                            </StyledTableCell>
                            <StyledTableCell>Card - Pine Labs</StyledTableCell>
                            <StyledTableCell rowSpan={2}>
                                Total (Automatic)
                            </StyledTableCell>
                            <StyledTableCell>Cheque</StyledTableCell>
                            <StyledTableCell>
                                Card - Pine Labs (not via ERP)
                            </StyledTableCell>
                            <StyledTableCell>
                                Bank Transfers - Non Virtual Account
                            </StyledTableCell>
                            <StyledTableCell>Cash</StyledTableCell>
                            <StyledTableCell>Others</StyledTableCell>
                            <StyledTableCell rowSpan={2}>
                                Total (Manual)
                            </StyledTableCell>
                        </StyledTableRow>
                    </TableHead>

                    <TableBody>
                        {approvedPaymentData?.map((el, i) => {
                            return (
                                <StyledTableRow key={i + 1}>
                                    <StyledTableCell>
                                        {el?.date !== "Grand Total"
                                            ? i + 1
                                            : ""}
                                    </StyledTableCell>
                                    <StyledTableCell
                                        style={{
                                            fontWeight: `${
                                                el?.date === "Grand Total"
                                                    ? "700"
                                                    : ""
                                            }`,
                                        }}
                                    >
                                        {el?.date}
                                    </StyledTableCell>
                                    <StyledTableCell
                                        align="right"
                                        style={{
                                            fontWeight: `${
                                                el?.date === "Grand Total"
                                                    ? "700"
                                                    : ""
                                            }`,
                                        }}
                                        className={classes.clickableTableCell}
                                        onClick={() => {
                                            showDetailedModalHandler(
                                                el?.Automatic?.UPI?.data,
                                                "Automatic UPI Total | " + el?.date,
                                            );
                                        }}
                                    >
                                        {commaSeparateAmount(el?.Automatic?.UPI?.total / 100000)}
                                        {/* {el?.Automatic?.UPI?.total?.toFixed(2)} */}
                                        {/* 
                                        {el?.Automatic?.UPI?.total?.toLocaleString(
                                            "en-IN",
                                            {
                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                // style: "currency",
                                                currency: "INR",
                                            }
                                        )}
                                        */}
                                    </StyledTableCell>
                                    <StyledTableCell
                                        align="right"
                                        style={{
                                            fontWeight: `${
                                                el?.date === "Grand Total"
                                                    ? "700"
                                                    : ""
                                            }`,
                                        }}
                                        className={classes.clickableTableCell}
                                        onClick={() => {
                                            showDetailedModalHandler(
                                                el?.Automatic?.Cash_Free?.data,
                                                "Automatic Cash Free Total | " + el?.date,
                                            );
                                        }}
                                    >
                                        {commaSeparateAmount(el?.Automatic?.Cash_Free?.total / 100000)}
                                        {/* {el?.Automatic?.Cash_Free?.total?.toFixed(2)} */}
                                        {/*
                                        {el?.Automatic?.Cash_Free?.total?.toLocaleString(
                                            "en-IN",
                                            {
                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                // style: "currency",
                                                currency: "INR",
                                            }
                                        )}
                                        */}
                                    </StyledTableCell>
                                    <StyledTableCell
                                        align="right"
                                        style={{
                                            fontWeight: `${
                                                el?.date === "Grand Total"
                                                    ? "700"
                                                    : ""
                                            }`,
                                        }}
                                        className={classes.clickableTableCell}
                                        onClick={() => {
                                            showDetailedModalHandler(
                                                el?.Automatic?.Bank_Transfer_Virtual_Payment?.data,
                                                "Automatic Bank Transfer Virtual Payment Total | " + el?.date,
                                            );
                                        }}
                                    >
                                        {commaSeparateAmount(el?.Automatic?.Bank_Transfer_Virtual_Payment?.total / 100000)}
                                        {/* {el?.Automatic?.Bank_Transfer_Virtual_Payment?.total?.toFixed(2)} */}
                                        {/*
                                        {el?.Automatic?.Bank_Transfer_Virtual_Payment?.total?.toLocaleString(
                                            "en-IN",
                                            {
                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                // style: "currency",
                                                currency: "INR",
                                            }
                                        )}
                                        */}
                                    </StyledTableCell>
                                    <StyledTableCell
                                        align="right"
                                        style={{
                                            fontWeight: `${
                                                el?.date === "Grand Total"
                                                    ? "700"
                                                    : ""
                                            }`,
                                        }}
                                        className={classes.clickableTableCell}
                                        onClick={() => {
                                            showDetailedModalHandler(
                                                el?.Automatic?.Card_Pine_Labs?.data,
                                                "Automatic Card Pine Labs Total | " + el?.date,
                                            );
                                        }}
                                    >
                                        {commaSeparateAmount(el?.Automatic?.Card_Pine_Labs?.total / 100000)}
                                        {/* {el?.Automatic?.Card_Pine_Labs?.total?.toFixed(2)} */}
                                        {/*
                                        {el?.Automatic?.Card_Pine_Labs?.total?.toLocaleString(
                                            "en-IN",
                                            {
                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                // style: "currency",
                                                currency: "INR",
                                            }
                                        )}
                                        */}
                                    </StyledTableCell>
                                    <StyledTableCell
                                        align="right"
                                        style={{
                                            fontWeight: `${
                                                el?.date === "Grand Total"
                                                    ? "700"
                                                    : ""
                                            }`,
                                        }}
                                        className={classes.clickableTableCell}
                                        onClick={() => {
                                            showDetailedModalHandler(
                                                el?.Automatic?.grandTotal?.data,
                                                "Automatic Total | " + el?.date,
                                            );
                                        }}
                                    >
                                        {commaSeparateAmount(el?.Automatic?.grandTotal?.total / 100000)}
                                        {/* {el?.Automatic?.grandTotal?.total?.toFixed(2)} */}
                                        {/*
                                        {el?.Automatic?.grandTotal?.total?.toLocaleString(
                                            "en-IN",
                                            {
                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                // style: "currency",
                                                currency: "INR",
                                            }
                                        )}
                                        */}
                                    </StyledTableCell>
                                    <StyledTableCell
                                        align="right"
                                        style={{
                                            fontWeight: `${
                                                el?.date === "Grand Total"
                                                    ? "700"
                                                    : ""
                                            }`,
                                        }}
                                        className={classes.clickableTableCell}
                                        onClick={() => {
                                            showDetailedModalHandler(
                                                el?.Manual?.Cheque?.data,
                                                "Manual Cheque Total | " + el?.date,
                                            );
                                        }}
                                    >
                                        {commaSeparateAmount(el?.Manual?.Cheque?.total / 100000)}
                                        {/* {el?.Manual?.Cheque?.total?.toFixed(2)} */}
                                        {/*
                                        {el?.Manual?.Cheque?.total?.toLocaleString(
                                            "en-IN",
                                            {
                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                // style: "currency",
                                                currency: "INR",
                                            }
                                        )}
                                        */}
                                    </StyledTableCell>
                                    <StyledTableCell
                                        align="right"
                                        style={{
                                            fontWeight: `${
                                                el?.date === "Grand Total"
                                                    ? "700"
                                                    : ""
                                            }`,
                                        }}
                                        className={classes.clickableTableCell}
                                        onClick={() => {
                                            showDetailedModalHandler(
                                                el?.Manual?.Card_Pine_Labs?.data,
                                                "Manual Card Pine Labs Total | " + el?.date,
                                            );
                                        }}
                                    >
                                        {commaSeparateAmount(el?.Manual?.Card_Pine_Labs?.total / 100000)}
                                        {/* {el?.Manual?.Card_Pine_Labs?.total?.toFixed(2)} */}
                                        {/*
                                        {el?.Manual?.Card_Pine_Labs?.total?.toLocaleString(
                                            "en-IN",
                                            {
                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                // style: "currency",
                                                currency: "INR",
                                            }
                                        )}
                                        */}
                                    </StyledTableCell>
                                    <StyledTableCell
                                        align="right"
                                        style={{
                                            fontWeight: `${
                                                el?.date === "Grand Total"
                                                    ? "700"
                                                    : ""
                                            }`,
                                        }}
                                        className={classes.clickableTableCell}
                                        onClick={() => {
                                            showDetailedModalHandler(
                                                el?.Manual?.Bank_Transfer_Non_Virtual_Payment?.data,
                                                "Manual Bank Transfer Non Virtual Payment Total | " + el?.date,
                                            );
                                        }}
                                    >
                                        {commaSeparateAmount(el?.Manual?.Bank_Transfer_Non_Virtual_Payment?.total / 100000)}
                                        {/* {el?.Manual?.Bank_Transfer_Non_Virtual_Payment?.total?.toFixed(2)} */}
                                        {/*
                                        {el?.Manual?.Bank_Transfer_Non_Virtual_Payment?.total?.toLocaleString(
                                            "en-IN",
                                            {
                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                // style: "currency",
                                                currency: "INR",
                                            }
                                        )}
                                        */}
                                    </StyledTableCell>
                                    <StyledTableCell
                                        align="right"
                                        style={{
                                            fontWeight: `${
                                                el?.date === "Grand Total"
                                                    ? "700"
                                                    : ""
                                            }`,
                                        }}
                                        className={classes.clickableTableCell}
                                        onClick={() => {
                                            showDetailedModalHandler(
                                                el?.Manual?.Cash?.data,
                                                "Manual Cash Total | " + el?.date,
                                            );
                                        }}
                                    >
                                        {commaSeparateAmount(el?.Manual?.Cash?.total / 100000)}
                                        {/* {el?.Manual?.Cash?.total?.toFixed(2)} */}
                                        {/*
                                        {el?.Manual?.Cash?.total?.toLocaleString(
                                            "en-IN",
                                            {
                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                // style: "currency",
                                                currency: "INR",
                                            }
                                        )}
                                        */}
                                    </StyledTableCell>
                                    <StyledTableCell
                                        align="right"
                                        style={{
                                            fontWeight: `${
                                                el?.date === "Grand Total"
                                                    ? "700"
                                                    : ""
                                            }`,
                                        }}
                                        className={classes.clickableTableCell}
                                        onClick={() => {
                                            showDetailedModalHandler(
                                                el?.Manual?.Others?.data,
                                                "Manual Others Total | " + el?.date,
                                            );
                                        }}
                                    >
                                        {commaSeparateAmount(el?.Manual?.Others?.total / 100000)}
                                        {/* {el?.Manual?.Others?.total?.toFixed(2)} */}
                                        {/*
                                        {el?.Manual?.Others?.total?.toLocaleString(
                                            "en-IN",
                                            {
                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                // style: "currency",
                                                currency: "INR",
                                            }
                                        )}
                                        */}
                                    </StyledTableCell>
                                    <StyledTableCell
                                        align="right"
                                        style={{
                                            fontWeight: `${
                                                el?.date === "Grand Total"
                                                    ? "700"
                                                    : ""
                                            }`,
                                        }}
                                        className={classes.clickableTableCell}
                                        onClick={() => {
                                            showDetailedModalHandler(
                                                el?.Manual?.grandTotal?.data,
                                                "Manual Total | " + el?.date,
                                            );
                                        }}
                                    >
                                        {commaSeparateAmount(el?.Manual?.grandTotal?.total / 100000)}
                                        {/* {el?.Manual?.grandTotal?.total?.toFixed(2)} */}
                                        {/*
                                        {el?.Manual?.grandTotal?.total?.toLocaleString(
                                            "en-IN",
                                            {
                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                // style: "currency",
                                                currency: "INR",
                                            }
                                        )}
                                        */}
                                    </StyledTableCell>
                                    <StyledTableCell
                                        align="right"
                                        style={{
                                            fontWeight: "700",
                                        }}
                                        className={classes.clickableTableCell}
                                        onClick={() => {
                                            showDetailedModalHandler(
                                                el?.grandTotal?.data,
                                                "Grand Total | " + el?.date,
                                            );
                                        }}
                                    >
                                        {commaSeparateAmount(el?.grandTotal?.total / 100000)}
                                        {/* {el?.grandTotal?.total?.toFixed(2)} */}
                                        {/*
                                        {el?.grandTotal?.total?.toLocaleString(
                                            "en-IN",
                                            {
                                                maximumFractionDigits: 2, // Maximum number of decimal places
                                                // style: "currency",
                                                currency: "INR",
                                            }
                                        )}
                                        */}
                                    </StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                    {/*
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[
                                    50,
                                    100,
                                    200,
                                    {
                                        label: "All",
                                        value: totalPages ? totalPages : "",
                                    },
                                ]}
                                colSpan={8}
                                count={totalPages}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                    inputProps: {
                                        "aria-label": "rows per page",
                                    },
                                    native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </TableRow>
                    </TableFooter>
                    */}
                </Table>
            </TableContainer>

            <Dialog
                open={showExcelFileFormat}
                onClose={() => setShowExcelFileFormat(false)}
                // fullWidth
                maxWidth="md"
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent>
                    <DialogContentText>
                        <b
                            // style={{color: "red"}}
                            style={{
                                color: 'red',
                                fontWeight: 'bold',
                                textShadow: '0 0 5px yellow'
                            }}
                        >
                            Please check the column positions and ensure the file to be uploaded has matching column names and positions as shown in the highlighted preview below <span style={{ color: "black" }}>(for {paymentFileUploadType || "N/A"} {paymentFileUploadType === paymentMode.cashFree ? "Please don't edit file before upload" : ""})</span>.
                            This will help prevent errors during processing. Focus on the three highlighted columns, as their names and positions must match between both files.
                            Ensure the required fields are correctly positioned in your file.
                        </b>
                    </DialogContentText>
                </DialogContent>
                <img src={
                    (paymentFileUploadType === paymentMode.cashFree ? CashFreeExcelFilePreview : paymentFileUploadType === paymentMode.cardPineLabsErp ? CardPineLabExcelFilePreview : "")
                } alt="Please Select the Payment File Type to Preview" />
            </Dialog>

            {/* Detailed Modal On Click for Transactions */}
			<Modal
				title={title}
				centered
				open={showDetailedModal}
				onCancel={() => setShowDetailedModal(false)}
				width={1000}
				maskClosable={true}
				footer={null}
			>
				<div className={classes.csv}>
					<CSVLink
						headers={headersForDetailedTrx}
						filename={title.replace("|", "-") + ".csv"}
						data={csvDataForDetailedTrx}
						ref={csvButtonRefForDetailedTrx}
					/>
					<Button
						onClick={csvDownloadHandlerForDetailedTrx}
						style={{ backgroundColor: "#355025",color:"#FFF2EB", marginBottom: 20 }}
						variant="contained"
					>
						Download CSV
					</Button>
				</div>

				{detailDataArray && (
					<TableContainer component={Paper} className={classes.table}>
						<Table
							style={{ width: "fit-content" }}
							className={classes.table}
							stickyHeader
							aria-label="sticky table"
						>
							<TableHead>
								<StyledTableRow>
									<StyledTableCell>Sl. No.</StyledTableCell>
									<StyledTableCell>Unique Lead No</StyledTableCell>
									<StyledTableCell>Lead No.</StyledTableCell>
									<StyledTableCell>Customer Name</StyledTableCell>
									<StyledTableCell>Payment Mode</StyledTableCell>
									<StyledTableCell>Trx Id</StyledTableCell>
									<StyledTableCell>Amount Received</StyledTableCell>
                                    <StyledTableCell>Bank Charges</StyledTableCell>
									<StyledTableCell>GST</StyledTableCell>
									<StyledTableCell>Net Amount Received</StyledTableCell>
									<StyledTableCell>Bank Receipt Date</StyledTableCell>
									<StyledTableCell>Status</StyledTableCell>
									<StyledTableCell>Department</StyledTableCell>
									
								</StyledTableRow>
							</TableHead>
							<TableBody>
								{detailDataArray?.map((data, i) => {
									return (
										<StyledTableRow key={i}>
											<StyledTableCell component="th">{i + 1}</StyledTableCell>
											<StyledTableCell
												component="th"
												style={{ textAlign: "center" }}
											>
												{
													data.leadId ?
														<Link to={`/project-logs/${data?.leadId?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data?.leadId?.uniqueLeadNumber}</Link> :
														'NA'
												}
											</StyledTableCell>
											<StyledTableCell
												component="th"
												style={{ textAlign: "center" }}
											>
												{
													data?.leadId ?
														<Link to={`/project-logs/${data?.leadId?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data?.leadId?.lead_no}</Link> :
														'NA'
												}
											</StyledTableCell>
											<StyledTableCell
												component="th"
												style={{ textAlign: "center" }}
											>
												{data?.leadId?.customerId?.name}
											</StyledTableCell>
											<StyledTableCell
												component="th"
												style={{ textAlign: "center" }}
											>
												{data?.selectedPaymentMode}
											</StyledTableCell>
                                            <StyledTableCell
												component="th"
												style={{ textAlign: "center" }}
											>
												{data?.trxId || "N/A"}
											</StyledTableCell>
                                            <StyledTableCell
												component="th"
												style={{ textAlign: "center" }}
											>
												{data?.Amount_Received  || 0}
											</StyledTableCell>
                                            <StyledTableCell
												component="th"
												style={{ textAlign: "center" }}
											>
												{data?.bankCharges  || 0}
											</StyledTableCell>
                                            <StyledTableCell
												component="th"
												style={{ textAlign: "center" }}
											>
												{data?.gstAmount  || 0}
											</StyledTableCell>
                                            <StyledTableCell
												component="th"
												style={{ textAlign: "center" }}
											>
												{(data?.Amount_Received - data?.bankCharges - data?.gstAmount)  || 0}
											</StyledTableCell>
                                            <StyledTableCell
												component="th"
												style={{ textAlign: "center" }}
											>
												{data?.formattedDate}
											</StyledTableCell>
                                            <StyledTableCell
												component="th"
												style={{ textAlign: "center" }}
											>
												{data?.Status}
											</StyledTableCell>
                                            <StyledTableCell
												component="th"
												style={{ textAlign: "center" }}
											>
												{data?.departmentId?.name || "N/A"}
											</StyledTableCell>
										</StyledTableRow>
									);
								})}
							</TableBody>
						</Table>
					</TableContainer>
				)}
			</Modal>
        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo })(
    ApprovedPaymentReceivedAnalysis
);
